import { ElementRef } from '@angular/core';
import { ThemePalette } from './theme.types';

export type Constructor<T> = new (...args: any[]) => T;
export type AbstractConstructor<T = object> = abstract new (
  ...args: any[]
) => T;

export interface CanColor {
  color: ThemePalette;
  defaultColor: ThemePalette;
}

export interface HasElementRef {
  _elementRef: ElementRef;
}

type CanColorCtor = Constructor<CanColor> & AbstractConstructor<CanColor>;

/** Mixin to augment a directive with a `color` property. */
export function mixinColor<T extends AbstractConstructor<HasElementRef>>(
  base: T,
  defaultColor?: ThemePalette,
): CanColorCtor & T;

export function mixinColor<T extends Constructor<HasElementRef>>(
  base: T,
  defaultColor?: ThemePalette,
): CanColorCtor & T {
  return class extends base {
    private _color!: ThemePalette;
    defaultColor = defaultColor;

    get color(): ThemePalette {
      return this._color;
    }
    set color(value: ThemePalette) {
      const colorPalette = value || this.defaultColor;

      if (colorPalette !== this._color) {
        if (this._color) {
          this._elementRef.nativeElement.classList.remove(`yoo-${this._color}`);
        }
        if (colorPalette) {
          this._elementRef.nativeElement.classList.add(`yoo-${colorPalette}`);
        }

        this._color = colorPalette;
      }
    }

    constructor(...args: any[]) {
      super(...args);

      // Set the default color that can be specified from the mixin.
      this.color = defaultColor!;
    }
  } as any;
}
